module.exports = __webpack_public_path__ + "static/media/proof-of-address_wrong.877a8e1c.png";